import { EventEmitter, Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import { Recording, RecordingMatchModel } from '../entities/recordings.model';

@Injectable({
  providedIn: 'root'
})
export class RecordingsService {

  public isMatching = false;
  public recordToMatch: Recording;
  public recordMatched = new EventEmitter(false);

  constructor(
    private apiService: ApiService
  ) { }

  public refreshRecordings(): Observable<RestResponse> {
    const url = API.Recordings.get;
    return this.apiService.get(url);
  }

  public importRecordings(): Observable<RestResponse> {
    const url = API.Recordings.import;
    return this.apiService.post(url);
  }

  public linkRecordings(): Observable<RestResponse> {
    const url = API.Recordings.link;
    return this.apiService.post(url);
  }

  public deleteRecordings(id: number): Observable<RestResponse> {
    const url = `${API.Recordings.delete}?id=${id}`;
    return this.apiService.delete(url);
  }

  private matchRecordings(model: RecordingMatchModel): Observable<RestResponse> {
    const url = API.Recordings.match;
    return this.apiService.post(url, model);
  }

  public mapRecordings(resultSet: Array<Recording>): Array<Recording> {
    const recordings = new Array<Recording>();
    resultSet.forEach(result => {
      recordings.push(new Recording({
        grabacionId: result.grabacionId,
        grabacion: result.grabacion,
        actuacionId: result.actuacionId,
        bajaId: result.bajaId,
        duracion: result.duracion,
        eliminada: result.eliminada,
        fecha: result.fecha,
        ficheroOriginal: result.ficheroOriginal,
        llamadaTrabajador: result.llamadaTrabajador,
        telefono: result.telefono,
        trabajadorId: result.trabajadorId
      }));
    });
    return recordings;
  }

  public acceptMatch(actuacion: any): Observable<RestResponse> {
    const match = new RecordingMatchModel();
    match.ActuacionId = actuacion.actuacionId;
    match.BajaId = actuacion.bajaId;
    match.TrabajadorId = actuacion.trabajadorId;
    match.GrabacionId = this.recordToMatch.grabacionId;

    this.recordToMatch = null;
    this.isMatching = false;
    return this.matchRecordings(match);
  }

  public getAudioFile(id: number): Observable<RestResponse> {
    const url = `${API.Recordings.audio}?id=${id}`;
    return this.apiService.get(url);
  }
}
